<template>
    <div class="status-flag">
        <div class="status-flag--option" :class="{'__focus':status == 1}" @click="changeStatus(1)">
            <img src="@/assets/images/on-car.png" />
            <p>在线</p>
        </div>
        <div class="status-flag--option" :class="{'__focus':status == 2}" @click="changeStatus(2)">
            <img src="@/assets/images/off-car.png" />
            <p>离线</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return ({
            status: 0
        })
    },
    methods: {
        changeStatus(val) {
            if((val == 1 && this.status == 1) || (val == 2 && this.status == 2)){
                this.status =0
            }else{
                this.status = val;
            }

            this.$emit("change",this.status)
        }
    },
}
</script>
<style lang="scss" scoped>
.status-flag {
    width: 183px;
    height: 42px;
    position: absolute;
    top: 40px;
    right: 30px;
    z-index: 400;
    display: flex;
    justify-content: space-around;
    background-color: rgba(255, 255, 255, 0.56);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.21);
    border-radius: 4px;
    font-size: 14px;
    &--option {
        display: flex;
        align-items: center;
        > img {
            width: 24px;
            height: 28px;
            margin-right: 5px;
        }
    }
    &.filter-status{
        width: auto;
        background: transparent;
        .status-flag--option{
            padding: 0px 15px;
            background: rgba(255,255,255,0.50);
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.21);
            border-radius: 4px;
            margin-right: 10px;
            border: 1px solid transparent;
            cursor: pointer;
            >img{
                width: 24PX;
                height: 28PX;
                margin-right: 10px;
            }
            p{
                margin: 0;
            }
            &:last-child{
                margin-right: 0;
            }
            &.__focus{
                background: rgba(1,46,102,0.50);
                border-color: #00BCFC;
                box-shadow: 0 4px 6px 0 rgba(13,188,252,0.52);
                color: #FFFFFF;
            }
        }
    }
}
</style>
